<template>
    <div
        :class="$style.wrapper"
        data-interface-section="brand-preloader-error-state"
    >
        <img
            :src="randomImage"
            :alt="label"
            :class="[$style.image, $style.image_animated]"
        />
        <Typography
            type="label"
            size="l"
            :class="$style.label"
        >
            {{ label }}
        </Typography>
        <Button
            size="m"
            interfaceTarget="brand-preloader-continue-button"
        >
            {{ $tr('brandPreloader.continuePlaying') }}
        </Button>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Button from '@/components_new/Button.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { OutOfPageAdType } from '@/modules/adv'

import imgBackpack from './images/img-backpack.webp'
import imgBall from './images/img-ball.webp'
import imgGum from './images/img-gum.webp'
import imgHeart from './images/img-heart.webp'
import imgPigeon from './images/img-pigeon.webp'

interface Props {
    adType: OutOfPageAdType | null
}

const tr = useTr()

const { adType } = defineProps<Props>()

const label = computed(() => (adType === 'rewarded' ? tr('brandPreloader.reward') : tr('brandPreloader.adSkipped')))

const randomImage = computed(() => {
    const images = [imgBackpack, imgBall, imgGum, imgHeart, imgPigeon]
    return images[Math.floor(Math.random() * images.length)]
})
</script>

<style module>
.wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.label {
    margin: 16px 0 20px;
}

.image {
    width: clamp(140px, 15%, 180px);
    aspect-ratio: 1 / 1;
}

.image_animated {
    animation: bounceIn 1.4s ease-in-out forwards;
}

@keyframes bounceIn {
    from,
    20%,
    40%,
    60%,
    80%,
    to {
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
        opacity: 0;
        transform: scale(0.3);
    }

    20% {
        transform: scale(1.1);
    }

    40% {
        transform: scale(0.9);
    }

    60% {
        opacity: 1;
        transform: scale(1.03);
    }

    80% {
        transform: scale(0.97);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
